export default {
    jp: {
        LP: {
            // 言語切り替えボタン
            change_locale: 'English',


            // OGP用情報
            ogp: {
                title: '',
                description: '',
                type: 'website',
                url: '',
                site_name: '',
                image: '/Images/Ogp/OGP.jpg',
                twitter_card: 'summary_large_image'
            },

            // INTRO
            intro: {
                headering: '2021.10.16 - 2022.4.10',
                h_caption: '※東京メガイルミの開催日時に準じます。',
                url: 'https://www.tokyomegaillumi.jp/',
                lead_sp: '東京・大井競馬場' +
                    '\r\n' +
                    '「TOKYO MEGA ILLUMINATION」内',
                lead_pc: '東京・大井競馬場「TOKYO MEGA ILLUMINATION」内',
                hashtag1: '#東京メガイルミ',
                hashtag2: '#大井競馬場',
                hashtag3: '#nakedinc',
                hashtag4: '#ネイキッドインク',
                hashtag: [{
                        tag: '#東京メガイルミ',
                    },
                    {
                        tag: '#大井競馬場',
                    },
                    {
                        tag: '#ネイキッドインク',
                    },
                    {
                        tag: '#nakedinc',
                    },
                ],
            },


            //新型コロナウイルス感染症対策について
            covid19: {
                title: '感染症対策について',
                notice: '1日の入場者数に制限がございます',
                caption: '人数制限のため、チケットの販売枚数を制限しています。' +
                    '\r\n' +
                    '前売りチケットのご購入をおすすめいたします。',
                detail: '詳細はこちら',
                spec: '以下の条件に当てはまる方はご来場をお断りしております。',
            },
            covid19_guide1: [{
                    thumbnail: './Images/covid/corona_pic_01_black.svg',
                    description: '入場時の検温で37.5℃以上の発熱がある方',
                },
                {
                    thumbnail: './Images/covid/corona_pic_02_black.svg',
                    description: '発熱・倦怠感など、体調がすぐれない方',
                },

            ],
            covid19_guide2: [{
                    thumbnail: './Images/covid/corona_pic_06_black.svg',
                    description: 'ご来場の際はマスクの着用をし、咳エチケットにご協力ください。',
                },
                {
                    thumbnail: './Images/covid/corona_pic_05_black.svg',
                    description: '入場時、消毒液で手指の消毒をお願いします。入場後にもアルコール除菌アートを設置しております。',
                },
                {
                    thumbnail: './Images/covid/corona_pic_03_black.svg',
                    description: '場内でのソーシャルディスタンスの確保をお願いします。',
                },
                {
                    thumbnail: './Images/covid/corona_pic_04_black.svg',
                    description: 'マスクを外される際は、なるべく他の人との距離を保ち、大声での会話はご遠慮ください。',
                },
            ],

            //推奨環境について
            spec: {
                title: '推奨環境',
                browser: {
                    title: '＜OS／ブラウザ＞',
                    text: 
                        'iOS  safari/Chrome iOS12以上　（設定->Safari->詳細->Experimental Features->Webgl2をONにする必要があります。）' +
                        '\r\n' +
                        'Android 5.0以上　Chrome 90以上' +
                        '\r\n' +
                        'Android 5.0以上　AndroidBrowser(標準でインストールされているブラウザ) 92以上' +
                        '\r\n' +
                        'Samsung Internet( Garaxy等のSamsung製品に標準でインストールされているブラウザ)7.2以上' +
                        '\r\n' +
                        '※各ブラウザは最新のバージョンへのアップデートを推奨いたします。',
                },
                function: {
                    title: '＜端末必要機能＞',
                    text: 'wifi版のiPadにはGPSが付いていませんので注意が必要です。' +
                        '\r\n' +
                        'wifi版のiPadにはGPSが付いていませんので注意が必要です。' +
                        '\r\n' +
                        '※また、端末の様々な条件により、上記条件においても全ての機種にて動作の保証はされません。',
                },
            },

            //BIG BOOK
            big_book: {
                renewal: 'リニューアルについて',
                renewal_caption: '2018年10月年の誕生以来、多くの人に親しまれてきたTWINくるくるファンタジー。装いも新たに、リニューアルいたしました。新たなウェルカムエリアとして、クリエイティブカンパニーNAKED, INC.（ネイキッド）とコラボレーションすることで、これからもより多くの方の思い出に残る場所として、皆様をお待ちしています。',
                story: '演出ストーリー',
                story_caption: 'BIGBOOKから飛び出してきた白馬が光を使いながらメガイルミの世界をご案内します。白馬はとてもフレンドリー。ぜひメガイルミでたくさん遊んで仲良くなってください。',
            },


            // CONTENTS
            contents: {
                summary: 'ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。',
                more: '続きを読む',
                close: '閉じる',
            },
            contents_in: [{
                    image: './Images/contents/megaillumi_pers_BB.jpg',
                    title: '',
                    title_sub: '',
                    caption: '白馬が大きな本の中を駆け巡る！メガイルミの世界が本から飛び出してきたかのように楽しめます。ARを使った仕掛けもあるのでお楽しみください。「NAKED BIG BOOK」は、巨大な本のオブジェにプロジェクションマッピングを施し、ページがめくれるたびにその物語の世界へと誘うネイキッドの代表作品です。',
                },
                {
                    image: './Images/contents/megaillumi_pers_logo.jpg',
                    title: '',
                    title_sub: '',
                    caption: '"TOKYO CITY KEIBA"の文字はカラフルに光り、イルミネーションに包まれています。「NAKED BIG BOOK」の映像と連動し、映像の世界観を空間に拡張しています。',
                },
                {
                    image: './Images/contents/megaillumi_pers_int.jpg',
                    title: '',
                    title_sub: '',
                    caption: '[インタラクティブ]「NAKED BIG BOOK」から飛び出した白馬と一緒に遊ぼう！歩いたり、走ったりすると自分の足跡が蹄鉄（ていてつ）に変わります。',
                },
            ],
            contents_ar_in: [{
                    image: './Images/contents/megaillumi_pers_AR.jpg',
                    title: '白馬カメラフィルター',
                    title_sub: '',
                    caption: '大きな白馬が現れるカメラフィルター。好きな位置に動かして写真を撮ろう♪',
                },
                /* {
                    image: './Images/contents/megaillumi_pers_shibahu.jpg',
                    title: 'ARイルミネーション',
                    title_sub: '',
                    caption: '光と遊ぶ大樹と芝生広場で見ることができる、星のイルミネーション。空間に浮かぶロゴを探してね♪',
                }, */
            ],

            // PRICE
            price: {
                title: '体験料：無料',
                caption: '※東京メガイルミの入場料のみでお楽しみいただけます。',
                banner: './Images/banner/2021_ooimegaillumi_tgi_banner_pc@2x.png',
            },



            //CREDIT
            credit: {
                organizer: '主催',
                organizer_caption: '東京都競馬株式会社・特別区競馬組合',
                support: '特別協力',
                project: '企画・演出・制作',
                caption: '1997年に村松亮太郎が設立したクリエイティブカンパニー。"Core Creative, Total Creation, and Borderless Creativity"を理念に、映画やテレビ、MV、広告、空間演出、地方創生、教育プログラムなどジャンルを超えて手がけてきた。近年では、世界各地を繋ぐネットワーク型のアートプロジェクト「Breath / Bless Project」やAR/VR商品の開発など、オンライン・オフラインを超えた様々な体験を展開。アート、エンターテインメント、カルチャー、伝統、教育、音楽、都市、食、スポーツなど、LIFE(生活)のあらゆるSCENE(シーン)において新たな体験や価値を生み出している。',
            },

            buy_tickets: 'チケット購入',

        }


    },

}